import styled from 'styled-components';
import { Button } from 'reactstrap';

type CustomStyle = {
  customstyle?: string;
};
const StyledReactButton = styled(Button)<CustomStyle>`
  align-items: center;
  padding: 0.175rem 0.75rem;
  ${props => props.customstyle};
`;
export default StyledReactButton;
